import { connect } from 'react-redux';
import { download } from '@actions/conference';
import { changeSpeakerNames } from '@actions/transcript';
import { selectSpeakersFromTranscript, selectTranscriptId } from '@selectors/conference';
import { isSuperAdmin } from '@selectors/authentication';
import TranscriptHeaderComponent from './TranscriptHeader';

const mapStateToProps = (state) => ({
  locale: state.conference.locale,
  speakers: selectSpeakersFromTranscript(state),
  transcriptId: selectTranscriptId(state),
  isSuperAdmin: isSuperAdmin(state),
});

const mapDispatchToProps = {
  download,
  changeSpeakerNames,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranscriptHeaderComponent);



// WEBPACK FOOTER //
// ./components/organisms/TranscriptHeader/index.js